<template>
    <div>
        <v-icon x-small color="orange">mdi-circle</v-icon>
        <v-icon x-small color="orange">mdi-circle-outline</v-icon>
        <v-icon x-small color="orange">mdi-circle-outline</v-icon>
    </div>
</template>

<script>
export default {
    name: "IconQuantityLow"
}
</script>

<style scoped>

</style>
